/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 *
 */
angular.module('bulbApp.contentEditorModule')

.directive('blockCaption', ['$compile','$templateRequest','CONFIG', blockCaption]);

function blockCaption($compile, $templateRequest, CONFIG) {
  return {
    restrict: 'A',
    require: '^contentBlock',
    controller: 'BlockCaptionController as blockCaptionCtrl',
    link: function link(scope, element, attrs, contentBlockCtrl) {
      scope.contentBlockCtrl = contentBlockCtrl;
      $templateRequest('ajs/components/contenteditor/blockcaption.html').then(function(result) {
        var template = angular.element(result);
        element.after(template);
        $compile(template)(scope);
      });
    }
  };
}
